<template>
  <div>
    <a
    @click="openModal"
    class="btn-square-little-rich"
    >
      <b-icon pack="fas" icon="share-alt"></b-icon>
      <span class="button_text">{{$t("general.share")}}</span>
    </a>
    <div id="overlay" v-show="showContent" @click.self="closeModal">
      <div id="content" class="container">
        <div class="close-button" @click="closeModal()"><b-icon pack="fas" icon="times" size="is-medium" /></div>
        <font size="5" color="black"><h1>{{$t('share.url')}}</h1></font>
        <hr>
        <vue-qrcode v-if="URL" :value="URL" :options="QRoptions" tag="img"></vue-qrcode>
        <b-input  id="inputURL" type="text" :value="URL" size="is-large" readonly="readonly"></b-input>
        
        <div class="button_bar">
          <a
            class="btn-square-little-rich-wide"
            :data-clipboard-text="URL"
            @click="closeModal(); copyclip()"
            size="is-large"
            type="is-primary"
          >
            <b-icon pack="fas" icon="copy" />
            <span class="button_text">{{ $t("share.copy") }}</span>
          </a>

          <!--  公開ページへの別タブリンク
          <router-link target="_blank" :to="`/graph/${this.Gprm}`">
            <a
              class="btn-square-little-rich-wide"
              :data-clipboard-text="URL"
              size="is-large"
              type="is-primary"
            >
              <b-icon pack="fas" icon="external-link-alt" />
              <span class="button_text">{{ $t("general.sharepage") }}</span>
            </a>
          </router-link>
          -->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import clipboard from "clipboard";
import VueQrcode from "@chenfengyuan/vue-qrcode";
export default {
  components: {
    VueQrcode
  },
  props: {
    Gprm: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      clipBoard: null,
      showContent: false,
      URL: location.origin + "/graph/" + this.Gprm,
      QRoptions: {
        errorCorrectionLevel: "M",
        maskPattern: 0,
        margin: 10,
        scale: 2,
        width: 300,
        color: {
          dark: "#000000FF",
          light: "#FFFFFFFF"
        }
      }
    };
  },
  mounted() {
    this.clipBoard = new clipboard(".clipcopy")
  },
  updated() {
    this.URL = location.origin + "/graph/" + this.Gprm
  },
  methods: {
    copyclip(){
      navigator.clipboard
        .writeText(this.URL)
    },
    openModal() {
      this.showContent = true;
    },
    closeModal() {
      this.showContent = false;
    },
    push_sharepage() {
      this.$router.push({path: `/graph/${this.Gprm}`}, () => {})
    }
  }
};
</script>

<style scoped>
#overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
#content {
  z-index: 2;
  width: 50%;

  padding: 1em;
  background: #fff;
}
.button_bar{
  text-align:center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.btn-square-little-rich {
  position: relative;
  display: inline-block;
  padding: 10px 5px;
  text-decoration: none;
  color: #FFF;
  background:#2c6ac4;/*色*/
  border: solid 1px #2c6ac4;/*線色*/
  border-radius: 4px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.2);
  text-shadow: 0 1px 0 rgba(0,0,0,0.2);
  margin: 10px 15px;
  width: 160px;
  height: 50px;
}
.btn-square-little-rich:active {
  /*押したとき*/
  border: solid 1px #2c6ac4;
  box-shadow: none;
  text-shadow: none;
}
.btn-square-little-rich-wide {
  position: relative;
  display: inline-block;
  padding: 10px 5px;
  text-decoration: none;
  color: #FFF;
  background:#2c6ac4;/*色*/
  border: solid 1px #2c6ac4;/*線色*/
  border-radius: 4px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.2);
  text-shadow: 0 1px 0 rgba(0,0,0,0.2);
  margin: 10px 15px;
  width: 260px;
  height: 50px;
}
.btn-square-little-rich-wide:active {
  /*押したとき*/
  border: solid 1px #2c6ac4;
  box-shadow: none;
  text-shadow: none;
}
.button_text{
  padding: 30px 10px;
}
.close-button {
  margin-left: 95%;
  cursor: pointer;
}
</style>
